var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12ZM16.0607 11.0607C16.6464 10.4749 16.6464 9.52513 16.0607 8.93934C15.4749 8.35355 14.5251 8.35355 13.9393 8.93934L11 11.8787L10.0607 10.9393C9.47487 10.3536 8.52513 10.3536 7.93934 10.9393C7.35355 11.5251 7.35355 12.4749 7.93934 13.0607L9.93934 15.0607C10.5251 15.6464 11.4749 15.6464 12.0607 15.0607L16.0607 11.0607Z",
    fill: "#14BF86",
    stroke: "#14BF86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.6623779fae08475652d45dd312185c0d.svg";
export { ForwardRef as ReactComponent };